module.exports = __webpack_public_path__ + "img/enter-payment-details.31148c99.png";